import React from 'react';
import { motion } from 'framer-motion';
import { DownloadIcon, InfinityIcon, ShieldCheckIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { Logo } from '../Logo';
import { IMAGES } from '../../data/content';
interface HeroProps {
  ctaRef: React.RefObject<HTMLDivElement>;
}
const guarantees = [{
  icon: DownloadIcon,
  label: 'Descarga inmediata'
}, {
  icon: CreditCardIcon,
  label: 'Pago único'
}, {
  icon: InfinityIcon,
  label: 'Acceso de por vida'
}, {
  icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}];
export function Hero({
  ctaRef
}: HeroProps) {
  return <header className="w-full bg-cream px-4 pb-12 pt-7 sm:px-6 sm:pb-20 sm:pt-10" data-id="element-195" data-mp="vndne6tutjnk">
      <div className="mx-auto w-full max-w-content" data-id="element-196" data-mp="10lyoe8gxk7d2">
        <div className="flex justify-center" data-id="element-197" data-mp="10njjq0b2jubz">
          <Logo data-id="element-198" data-mp="15lbb8t7sxefn" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: 'easeOut'
      }} className="mt-7 text-balance text-center font-serif text-[31px] font-extrabold leading-[1.08] tracking-tight text-navy sm:text-5xl md:text-[56px]" data-id="element-199" data-mp="15m37m6983g6z">
          Resuelve un año entero de decisiones clínicas en diabetes en solo{' '}
          <span className="italic text-brand" data-id="element-200" data-mp="3vvasyh89wlfx">2 minutos</span> por paciente
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 14
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1,
        ease: 'easeOut'
      }} className="mx-auto mt-4 max-w-xl text-balance text-center text-[15px] font-medium leading-relaxed text-navy/70 sm:text-lg" data-id="element-201" data-mp="3rv0e0f2i6kox">
          Más de 2.000 médicos ya confían en el Sistema de Decisión Clínica. Llega a tu consulta con
          todo listo para diagnosticar, tratar y proteger a tus pacientes con diabetes, sin dudar ni
          una sola vez.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.15,
        ease: 'easeOut'
      }} className="mt-7 sm:mt-9" data-id="element-202" data-mp="16dtl7n0xyhtx">
          <img src={IMAGES.bundle} alt="Sistema de Decisión Clínica para Diabetes: 6 tomos, 5 herramientas clínicas y acceso móvil" className="mx-auto w-full max-w-lg" width={1080} height={1080} data-id="element-203" data-mp="35kh1wh169ys8" />
          <p className="mt-1 text-center text-[11px] font-bold uppercase tracking-[0.14em] text-navy/45" data-id="element-204" data-mp="2huwffo5t8je7">
            6 Tomos + 5 Herramientas Clínicas + Acceso móvil
          </p>
        </motion.div>

        <div ref={ctaRef} className="mt-8 sm:mt-10" data-id="element-205" data-mp="27y1llikhf769">
          <CTAButton label="✅ Quiero acceder al Sistema de Decisión Clínica" data-id="element-206" data-mp="27zcqxmtksmzh" />
        </div>

        <ul className="mx-auto mt-5 grid max-w-md grid-cols-2 gap-x-3 gap-y-2.5 sm:flex sm:max-w-none sm:flex-wrap sm:justify-center sm:gap-x-5" data-id="element-207" data-mp="2cyfhy3cq0sog">
          {guarantees.map(({
          icon: Icon,
          label
        }) => <li key={label} className="flex items-center gap-1.5 text-[12px] font-semibold text-navy/65 sm:text-[13px]" data-id="element-208" data-mp="b2vneoiqiet7">
              <Icon className="h-3.5 w-3.5 shrink-0 text-brand" aria-hidden="true" data-id="element-209" data-mp="1qp8ree4pd4jp" />
              {label}
            </li>)}
        </ul>
      </div>
    </header>;
}